export default __webpack_public_path__ + "static/media/recu8.27bbde09.png";